/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ClassroomdisciplineIdUsersMonitors200,
  GetApiV1ClassroomdisciplineIdUsersMonitors401,
  GetApiV1ClassroomdisciplineIdUsersMonitors404,
  GetApiV1ClassroomdisciplineIdUsersMonitorsPathParams,
  GetApiV1ClassroomdisciplineIdUsersMonitorsQueryResponse,
} from "../../types/classPlanningPeopleController/GetApiV1ClassroomdisciplineIdUsersMonitors.ts";
import { classroomUserPersonListItemViewModelSchema } from "../classroomUserPersonListItemViewModelSchema.ts";

export const getApiV1ClassroomdisciplineIdUsersMonitorsPathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1ClassroomdisciplineIdUsersMonitorsPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ClassroomdisciplineIdUsersMonitors200Schema = z.array(
  z.lazy(() => classroomUserPersonListItemViewModelSchema),
) as unknown as ToZod<GetApiV1ClassroomdisciplineIdUsersMonitors200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ClassroomdisciplineIdUsersMonitors401Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdUsersMonitors401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ClassroomdisciplineIdUsersMonitors404Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdUsersMonitors404>;

export const getApiV1ClassroomdisciplineIdUsersMonitorsQueryResponseSchema =
  z.lazy(
    () => getApiV1ClassroomdisciplineIdUsersMonitors200Schema,
  ) as unknown as ToZod<GetApiV1ClassroomdisciplineIdUsersMonitorsQueryResponse>;
